import { FINAL_ASSESSMENT_QUESTIONS, CATEGORIES as JAVA_CATEGORIES } from '@/data/finalAssessmentQuestions';
import { QUESTIONS as C_Q, CATEGORIES as C_CAT } from '@/data/i18n/assessment_c';
import { QUESTIONS as CPP_Q, CATEGORIES as CPP_CAT } from '@/data/i18n/assessment_cpp';
import { QUESTIONS as PY_Q, CATEGORIES as PY_CAT } from '@/data/i18n/assessment_python';

const BANKS = {
  java: { questions: FINAL_ASSESSMENT_QUESTIONS, categories: JAVA_CATEGORIES },
  c: { questions: C_Q, categories: C_CAT },
  cpp: { questions: CPP_Q, categories: CPP_CAT },
  python: { questions: PY_Q, categories: PY_CAT },
};

export const getAssessmentBank = (lang) => BANKS[lang] || BANKS.java;
